const compatModules = {};import * as Mod1 from "./discourse/components/modal/move-solution-confirmation";
compatModules["discourse/components/modal/move-solution-confirmation"] = Mod1;

export * as discourse$components$modal$move__solution__confirmation$$__module from "./discourse/components/modal/move-solution-confirmation";
export {
default as discourse$components$modal$move__solution__confirmation$$default
} from "./discourse/components/modal/move-solution-confirmation";
import * as Mod2 from "./discourse/components/modal/solved-removal-confirmation";
compatModules["discourse/components/modal/solved-removal-confirmation"] = Mod2;

export * as discourse$components$modal$solved__removal__confirmation$$__module from "./discourse/components/modal/solved-removal-confirmation";
export {
default as discourse$components$modal$solved__removal__confirmation$$default
} from "./discourse/components/modal/solved-removal-confirmation";
import * as Mod3 from "./discourse/components/solved-accept-answer-button";
compatModules["discourse/components/solved-accept-answer-button"] = Mod3;

export * as discourse$components$solved__accept__answer__button$$__module from "./discourse/components/solved-accept-answer-button";
export {
default as discourse$components$solved__accept__answer__button$$default
} from "./discourse/components/solved-accept-answer-button";
import * as Mod4 from "./discourse/components/solved-accepted-answer";
compatModules["discourse/components/solved-accepted-answer"] = Mod4;

export * as discourse$components$solved__accepted__answer$$__module from "./discourse/components/solved-accepted-answer";
export {
default as discourse$components$solved__accepted__answer$$default
} from "./discourse/components/solved-accepted-answer";
import * as Mod5 from "./discourse/components/solved-unaccept-answer-button";
compatModules["discourse/components/solved-unaccept-answer-button"] = Mod5;

export * as discourse$components$solved__unaccept__answer__button$$__module from "./discourse/components/solved-unaccept-answer-button";
export {
default as discourse$components$solved__unaccept__answer__button$$default
} from "./discourse/components/solved-unaccept-answer-button";
import * as Mod6 from "./discourse/components/upsert-category-support";
compatModules["discourse/components/upsert-category-support"] = Mod6;

export * as discourse$components$upsert__category__support$$__module from "./discourse/components/upsert-category-support";
export {
default as discourse$components$upsert__category__support$$default
} from "./discourse/components/upsert-category-support";
import * as Mod7 from "./discourse/connectors/after-topic-status/solved-status.gjs";
compatModules["discourse/connectors/after-topic-status/solved-status"] = Mod7;

export * as discourse$connectors$after__topic__status$solved__status$$__module from "./discourse/connectors/after-topic-status/solved-status.gjs";
export {
default as discourse$connectors$after__topic__status$solved__status$$default
} from "./discourse/connectors/after-topic-status/solved-status.gjs";
import * as Mod8 from "./discourse/connectors/bread-crumbs-right/solved-status-filter.gjs";
compatModules["discourse/connectors/bread-crumbs-right/solved-status-filter"] = Mod8;

export * as discourse$connectors$bread__crumbs__right$solved__status__filter$$__module from "./discourse/connectors/bread-crumbs-right/solved-status-filter.gjs";
export {
default as discourse$connectors$bread__crumbs__right$solved__status__filter$$default
} from "./discourse/connectors/bread-crumbs-right/solved-status-filter.gjs";
import * as Mod9 from "./discourse/connectors/category-custom-settings/solved-settings-upsert.gjs";
compatModules["discourse/connectors/category-custom-settings/solved-settings-upsert"] = Mod9;

export * as discourse$connectors$category__custom__settings$solved__settings__upsert$$__module from "./discourse/connectors/category-custom-settings/solved-settings-upsert.gjs";
export {
default as discourse$connectors$category__custom__settings$solved__settings__upsert$$default
} from "./discourse/connectors/category-custom-settings/solved-settings-upsert.gjs";
import * as Mod10 from "./discourse/connectors/category-custom-settings/solved-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/solved-settings"] = Mod10;

export * as discourse$connectors$category__custom__settings$solved__settings$$__module from "./discourse/connectors/category-custom-settings/solved-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$solved__settings$$default
} from "./discourse/connectors/category-custom-settings/solved-settings.gjs";
import * as Mod11 from "./discourse/connectors/topic-navigation/no-answer.gjs";
compatModules["discourse/connectors/topic-navigation/no-answer"] = Mod11;

export * as discourse$connectors$topic__navigation$no__answer$$__module from "./discourse/connectors/topic-navigation/no-answer.gjs";
export {
default as discourse$connectors$topic__navigation$no__answer$$default
} from "./discourse/connectors/topic-navigation/no-answer.gjs";
import * as Mod12 from "./discourse/connectors/user-activity-bottom/solved-list.gjs";
compatModules["discourse/connectors/user-activity-bottom/solved-list"] = Mod12;

export * as discourse$connectors$user__activity__bottom$solved__list$$__module from "./discourse/connectors/user-activity-bottom/solved-list.gjs";
export {
default as discourse$connectors$user__activity__bottom$solved__list$$default
} from "./discourse/connectors/user-activity-bottom/solved-list.gjs";
import * as Mod13 from "./discourse/connectors/user-card-metadata/accepted-answers.gjs";
compatModules["discourse/connectors/user-card-metadata/accepted-answers"] = Mod13;

export * as discourse$connectors$user__card__metadata$accepted__answers$$__module from "./discourse/connectors/user-card-metadata/accepted-answers.gjs";
export {
default as discourse$connectors$user__card__metadata$accepted__answers$$default
} from "./discourse/connectors/user-card-metadata/accepted-answers.gjs";
import * as Mod14 from "./discourse/connectors/user-preferences-notifications/solved-notifications.gjs";
compatModules["discourse/connectors/user-preferences-notifications/solved-notifications"] = Mod14;

export * as discourse$connectors$user__preferences__notifications$solved__notifications$$__module from "./discourse/connectors/user-preferences-notifications/solved-notifications.gjs";
export {
default as discourse$connectors$user__preferences__notifications$solved__notifications$$default
} from "./discourse/connectors/user-preferences-notifications/solved-notifications.gjs";
import * as Mod15 from "./discourse/connectors/user-summary-stat/solved-count.gjs";
compatModules["discourse/connectors/user-summary-stat/solved-count"] = Mod15;

export * as discourse$connectors$user__summary__stat$solved__count$$__module from "./discourse/connectors/user-summary-stat/solved-count.gjs";
export {
default as discourse$connectors$user__summary__stat$solved__count$$default
} from "./discourse/connectors/user-summary-stat/solved-count.gjs";
import * as Mod16 from "./discourse/initializers/add-topic-list-class";
compatModules["discourse/initializers/add-topic-list-class"] = Mod16;

export * as discourse$initializers$add__topic__list__class$$__module from "./discourse/initializers/add-topic-list-class";
export {
default as discourse$initializers$add__topic__list__class$$default
} from "./discourse/initializers/add-topic-list-class";
import * as Mod17 from "./discourse/initializers/extend-for-solved-button";
compatModules["discourse/initializers/extend-for-solved-button"] = Mod17;

export * as discourse$initializers$extend__for__solved__button$$__module from "./discourse/initializers/extend-for-solved-button";
export {
default as discourse$initializers$extend__for__solved__button$$default
} from "./discourse/initializers/extend-for-solved-button";
import * as Mod18 from "./discourse/initializers/solved-admin-plugin-configuration-nav";
compatModules["discourse/initializers/solved-admin-plugin-configuration-nav"] = Mod18;

export * as discourse$initializers$solved__admin__plugin__configuration__nav$$__module from "./discourse/initializers/solved-admin-plugin-configuration-nav";
export {
default as discourse$initializers$solved__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/solved-admin-plugin-configuration-nav";
import * as Mod19 from "./discourse/initializers/solved-category-change-confirmation";
compatModules["discourse/initializers/solved-category-change-confirmation"] = Mod19;

export * as discourse$initializers$solved__category__change__confirmation$$__module from "./discourse/initializers/solved-category-change-confirmation";
export {
default as discourse$initializers$solved__category__change__confirmation$$default
} from "./discourse/initializers/solved-category-change-confirmation";
import * as Mod20 from "./discourse/initializers/solved-category-type-tab";
compatModules["discourse/initializers/solved-category-type-tab"] = Mod20;

export * as discourse$initializers$solved__category__type__tab$$__module from "./discourse/initializers/solved-category-type-tab";
export {
default as discourse$initializers$solved__category__type__tab$$default
} from "./discourse/initializers/solved-category-type-tab";
import * as Mod21 from "./discourse/initializers/solved-user-options";
compatModules["discourse/initializers/solved-user-options"] = Mod21;

export * as discourse$initializers$solved__user__options$$__module from "./discourse/initializers/solved-user-options";
export {
default as discourse$initializers$solved__user__options$$default
} from "./discourse/initializers/solved-user-options";
import * as Mod22 from "./discourse/lib/set-accepted-solution";
compatModules["discourse/lib/set-accepted-solution"] = Mod22;

export * as discourse$lib$set__accepted__solution$$__module from "./discourse/lib/set-accepted-solution";
export {
default as discourse$lib$set__accepted__solution$$default
} from "./discourse/lib/set-accepted-solution";
import * as Mod23 from "./discourse/pre-initializers/solved-move-confirmation";
compatModules["discourse/pre-initializers/solved-move-confirmation"] = Mod23;

export * as discourse$pre__initializers$solved__move__confirmation$$__module from "./discourse/pre-initializers/solved-move-confirmation";
export {
default as discourse$pre__initializers$solved__move__confirmation$$default
} from "./discourse/pre-initializers/solved-move-confirmation";
import * as Mod24 from "./discourse/routes/user-activity/solved";
compatModules["discourse/routes/user-activity/solved"] = Mod24;

export * as discourse$routes$user__activity$solved$$__module from "./discourse/routes/user-activity/solved";
export {
default as discourse$routes$user__activity$solved$$default
} from "./discourse/routes/user-activity/solved";
import * as Mod25 from "./discourse/solved-route-map";
compatModules["discourse/solved-route-map"] = Mod25;

export * as discourse$solved__route__map$$__module from "./discourse/solved-route-map";
export {
default as discourse$solved__route__map$$default
} from "./discourse/solved-route-map";
import * as Mod26 from "./discourse/templates/user-activity/solved";
compatModules["discourse/templates/user-activity/solved"] = Mod26;

export * as discourse$templates$user__activity$solved$$__module from "./discourse/templates/user-activity/solved";
export {
default as discourse$templates$user__activity$solved$$default
} from "./discourse/templates/user-activity/solved";
export default compatModules;
